const tooltipFormActions = {
  edit: 'Editar',
  delete: 'Eliminar',
  equipment: 'Ir a los detalles del equipo',
  service: 'Ir a los detalles del servicio'
};

export default tooltipFormActions;
